const SYMBOLS = Object.freeze({
  amp: '&',
  hash: '#',
  percent: '%',
});

export default SYMBOLS;
